import React from 'react'
import { motion } from 'framer-motion'
import { Quote, Star } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

const Testimonials: React.FC = () => {
  const { t } = useLanguage()

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  }

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="text-center"
        >
          <motion.div
            variants={itemVariants}
            className="bg-white rounded-3xl p-12 shadow-2xl max-w-4xl mx-auto"
          >
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                <Quote className="h-8 w-8 text-white" />
              </div>
            </div>
            
            <motion.blockquote
              variants={itemVariants}
              className="text-2xl md:text-3xl font-medium text-gray-900 mb-8 leading-relaxed"
            >
              "{t('testimonials.quote')}"
            </motion.blockquote>
            
            <motion.div
              variants={itemVariants}
              className="flex items-center justify-center space-x-4"
            >
              <div className="flex space-x-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
            </motion.div>
            
            <motion.div
              variants={itemVariants}
              className="mt-8"
            >
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                <span className="text-white font-bold text-xl">B</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-900">{t('testimonials.author')}</h4>
              <p className="text-gray-600">{t('testimonials.position')}</p>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default Testimonials
